<template>
  <div>
    <!-- Show current language -->
    <div
      class="flex"
      role="button"
      tabindex="0"
      aria-label="Change language"
      @click="handleLanguageSwitchClick"
      @keydown.enter="handleLanguageSwitchClick"
    >
      <img
        src="@/assets/svg/icon_48px_language.svg"
        alt="Language"
      >
      <button
        :class="{ 'hidden': !withLabel, 'sm:inline-block': !withLabel }"
        class="text-zyxel-gray-800"
        aria-live="polite"
      >
        {{ currentLanguageLabel }}
      </button>
    </div>

    <!-- Language switch modal -->
    <div
      v-if="showModal"
      class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50 p-4"
    >
      <!-- Popup -->
      <div class="relative mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <!-- Content -->
        <div class="text-left">
          <h3>{{ $t('messages.language_switch.title') }}</h3>
          <button
            class="absolute top-0 right-0 mt-5 mr-5"
            aria-label="Close language switch"
            @click="handleLanguageSwitchClose"
          >
            <img
              class="h-8 w-8"
              src="@/assets/svg/icon_48px_close.svg"
              alt="Close"
            >
          </button>
          <div class="min-h-[180px] mt-6">
            <div
              v-for="(label, localeKey) in availableLanguages"
              :key="localeKey"
              class="mt-2"
            >
              <button
                :class="{ 'bg-zyxel-green-100': localeKey === locale }"
                class="b2 text-gray-900 hover:bg-zyxel-green-100 px-4 py-2 rounded w-full text-left"
                @click="changeLanguage(localeKey)"
              >
                {{ label }}
              </button>
            </div>
          </div>
          <!-- Close -->
          <div class="mt-5">
            <button
              class="button-cancel px-4 py-2 w-full"
              @click="handleLanguageSwitchClose"
            >
              {{ $t('messages.button.cancel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Cookies from 'js-cookie';
import { useAuthStore } from '@/stores/auth';
import { useI18nStore } from '@/stores/i18nStore';
import { logger } from '@/utils/logger';

export default {
  props: {
    withLabel: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, { emit }) {
    const { locale } = useI18n();
    const i18nStore = useI18nStore();
    const showModal = ref(false);

    const availableLanguages = {
      en: 'English',
      'zh-TW': '繁體中文'
    };

    const currentLanguageLabel = computed(() => availableLanguages[locale.value]);

    const changeLanguage = async (newLocale) => {
      await i18nStore.loadLanguage(newLocale);
      locale.value = newLocale;
      showModal.value = false;
      Cookies.set('v3_locale', newLocale);
      logger.log("change language to :" + newLocale);

      //update locale
      const authStore = useAuthStore();
      const languageData = {
          displayLanguage: newLocale
      };
      await authStore.updateUserLanguage(languageData);
      emit('language-switch-closed');
    };

    const triggerShowModal = () => {
      showModal.value = true;
    };
    const triggerCloseModal = () => {
      showModal.value = false;
    };

    return {
      showModal,
      availableLanguages,
      currentLanguageLabel,
      changeLanguage,
      triggerShowModal,
      triggerCloseModal,
      locale
    };
  },
  methods: {
    handleLanguageSwitchClick() {
      this.triggerShowModal();
    },
    handleLanguageSwitchClose() {
      this.$emit('language-switch-closed');
      this.triggerCloseModal();
    }
  }
};
</script>